import { FormattedMessage } from 'react-intl';

const PasswordsNotMatching = (): JSX.Element => {
  return (
    <FormattedMessage
      id="account_v2.components.form_errors.password.not_matching"
      defaultMessage="The passwords don't match."
    />
  );
};

export default PasswordsNotMatching;
